import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

type CarouselButtonProps = {
  handleClick: () => void;
  className?: string;
  style?: React.CSSProperties;
  Icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  type?: 'small' | 'large';
};

export default function CarouselButton({
  handleClick,
  className,
  style,
  Icon,
  type = 'small',
}: CarouselButtonProps) {
  return (
    <div
      style={style}
      className={twMerge(
        clsx(
          'cursor-pointer flex justify-center items-center rounded-full bg-neutral-50',
          className,
          {
            'size-6': type === 'small',
            'size-8': type === 'large',
          }
        )
      )}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleClick();
      }}
    >
      <Icon className="w-4 h-4 text-neutral-80" />
    </div>
  );
}
